document.addEventListener('alpine:init', () => {
    Alpine.data('countrySelector', () => ({
      open: false,
      // 默认选中美国
      selected: { name: 'United States', code: 'US', flag: 'us', dial_code: '+1 ' },
      phone: '+1 ',
      countries: [
        { name: 'Afghanistan', code: 'AF', flag: 'af', dial_code: '+93 ' },
        { name: 'Albania', code: 'AL', flag: 'al', dial_code: '+355 ' },
        { name: 'Algeria', code: 'DZ', flag: 'dz', dial_code: '+213 ' },
        { name: 'American Samoa', code: 'AS', flag: 'as', dial_code: '+1684 ' },
        { name: 'Andorra', code: 'AD', flag: 'ad', dial_code: '+376 ' },
        { name: 'Angola', code: 'AO', flag: 'ao', dial_code: '+244 ' },
        { name: 'Anguilla', code: 'AI', flag: 'ai', dial_code: '+1264 ' },
        { name: 'Antarctica', code: 'AQ', flag: 'aq', dial_code: '+672 ' },
        { name: 'Antigua and Barbuda', code: 'AG', flag: 'ag', dial_code: '+1268 ' },
        { name: 'Argentina', code: 'AR', flag: 'ar', dial_code: '+54 ' },
        { name: 'Armenia', code: 'AM', flag: 'am', dial_code: '+374 ' },
        { name: 'Aruba', code: 'AW', flag: 'aw', dial_code: '+297 ' },
        { name: 'Australia', code: 'AU', flag: 'au', dial_code: '+61 ' },
        { name: 'Austria', code: 'AT', flag: 'at', dial_code: '+43 ' },
        { name: 'Azerbaijan', code: 'AZ', flag: 'az', dial_code: '+994 ' },
        { name: 'Bahamas', code: 'BS', flag: 'bs', dial_code: '+1242 ' },
        { name: 'Bahrain', code: 'BH', flag: 'bh', dial_code: '+973 ' },
        { name: 'Bangladesh', code: 'BD', flag: 'bd', dial_code: '+880 ' },
        { name: 'Barbados', code: 'BB', flag: 'bb', dial_code: '+1246 ' },
        { name: 'Belarus', code: 'BY', flag: 'by', dial_code: '+375 ' },
        { name: 'Belgium', code: 'BE', flag: 'be', dial_code: '+32 ' },
        { name: 'Belize', code: 'BZ', flag: 'bz', dial_code: '+501 ' },
        { name: 'Benin', code: 'BJ', flag: 'bj', dial_code: '+229 ' },
        { name: 'Bermuda', code: 'BM', flag: 'bm', dial_code: '+1441 ' },
        { name: 'Bhutan', code: 'BT', flag: 'bt', dial_code: '+975 ' },
        { name: 'Bolivia', code: 'BO', flag: 'bo', dial_code: '+591 ' },
        { name: 'Bosnia and Herzegovina', code: 'BA', flag: 'ba', dial_code: '+387 ' },
        { name: 'Botswana', code: 'BW', flag: 'bw', dial_code: '+267 ' },
        { name: 'Brazil', code: 'BR', flag: 'br', dial_code: '+55 ' },
        { name: 'British Indian Ocean Territory', code: 'IO', flag: 'io', dial_code: '+246 ' },
        { name: 'Brunei Darussalam', code: 'BN', flag: 'bn', dial_code: '+673 ' },
        { name: 'Bulgaria', code: 'BG', flag: 'bg', dial_code: '+359 ' },
        { name: 'Burkina Faso', code: 'BF', flag: 'bf', dial_code: '+226 ' },
        { name: 'Burundi', code: 'BI', flag: 'bi', dial_code: '+257 ' },
        { name: 'Cambodia', code: 'KH', flag: 'kh', dial_code: '+855 ' },
        { name: 'Cameroon', code: 'CM', flag: 'cm', dial_code: '+237 ' },
        { name: 'Canada', code: 'CA', flag: 'ca', dial_code: '+1 ' },
        { name: 'Cape Verde', code: 'CV', flag: 'cv', dial_code: '+238 ' },
        { name: 'Cayman Islands', code: 'KY', flag: 'ky', dial_code: '+1345 ' },
        { name: 'Central African Republic', code: 'CF', flag: 'cf', dial_code: '+236 ' },
        { name: 'Chad', code: 'TD', flag: 'td', dial_code: '+235 ' },
        { name: 'Chile', code: 'CL', flag: 'cl', dial_code: '+56 ' },
        { name: 'China', code: 'CN', flag: 'cn', dial_code: '+86 ' },
        { name: 'Colombia', code: 'CO', flag: 'co', dial_code: '+57 ' },
        { name: 'Comoros', code: 'KM', flag: 'km', dial_code: '+269 ' },
        { name: 'Congo', code: 'CG', flag: 'cg', dial_code: '+242 ' },
        { name: 'Congo, Democratic Republic', code: 'CD', flag: 'cd', dial_code: '+243 ' },
        { name: 'Cook Islands', code: 'CK', flag: 'ck', dial_code: '+682 ' },
        { name: 'Costa Rica', code: 'CR', flag: 'cr', dial_code: '+506 ' },
        { name: 'Croatia', code: 'HR', flag: 'hr', dial_code: '+385 ' },
        { name: 'Cuba', code: 'CU', flag: 'cu', dial_code: '+53 ' },
        { name: 'Cyprus', code: 'CY', flag: 'cy', dial_code: '+357 ' },
        { name: 'Czech Republic', code: 'CZ', flag: 'cz', dial_code: '+420 ' },
        { name: 'Denmark', code: 'DK', flag: 'dk', dial_code: '+45 ' },
        { name: 'Djibouti', code: 'DJ', flag: 'dj', dial_code: '+253 ' },
        { name: 'Dominica', code: 'DM', flag: 'dm', dial_code: '+1767 ' },
        { name: 'Dominican Republic', code: 'DO', flag: 'do', dial_code: '+1 ' },
        { name: 'Ecuador', code: 'EC', flag: 'ec', dial_code: '+593 ' },
        { name: 'Egypt', code: 'EG', flag: 'eg', dial_code: '+20 ' },
        { name: 'El Salvador', code: 'SV', flag: 'sv', dial_code: '+503 ' },
        { name: 'Equatorial Guinea', code: 'GQ', flag: 'gq', dial_code: '+240 ' },
        { name: 'Eritrea', code: 'ER', flag: 'er', dial_code: '+291 ' },
        { name: 'Estonia', code: 'EE', flag: 'ee', dial_code: '+372 ' },
        { name: 'Eswatini', code: 'SZ', flag: 'sz', dial_code: '+268 ' },
        { name: 'Ethiopia', code: 'ET', flag: 'et', dial_code: '+251 ' },
        { name: 'Fiji', code: 'FJ', flag: 'fj', dial_code: '+679 ' },
        { name: 'Finland', code: 'FI', flag: 'fi', dial_code: '+358 ' },
        { name: 'France', code: 'FR', flag: 'fr', dial_code: '+33 ' },
        { name: 'French Polynesia', code: 'PF', flag: 'pf', dial_code: '+689 ' },
        { name: 'Gabon', code: 'GA', flag: 'ga', dial_code: '+241 ' },
        { name: 'Gambia', code: 'GM', flag: 'gm', dial_code: '+220 ' },
        { name: 'Georgia', code: 'GE', flag: 'ge', dial_code: '+995 ' },
        { name: 'Germany', code: 'DE', flag: 'de', dial_code: '+49 ' },
        { name: 'Ghana', code: 'GH', flag: 'gh', dial_code: '+233 ' },
        { name: 'Gibraltar', code: 'GI', flag: 'gi', dial_code: '+350 ' },
        { name: 'Greece', code: 'GR', flag: 'gr', dial_code: '+30 ' },
        { name: 'Greenland', code: 'GL', flag: 'gl', dial_code: '+299 ' },
        { name: 'Grenada', code: 'GD', flag: 'gd', dial_code: '+1473 ' },
        { name: 'Guam', code: 'GU', flag: 'gu', dial_code: '+1671 ' },
        { name: 'Guatemala', code: 'GT', flag: 'gt', dial_code: '+502 ' },
        { name: 'Guernsey', code: 'GG', flag: 'gg', dial_code: '+44 ' },
        { name: 'Guinea', code: 'GN', flag: 'gn', dial_code: '+224 ' },
        { name: 'Guinea-Bissau', code: 'GW', flag: 'gw', dial_code: '+245 ' },
        { name: 'Guyana', code: 'GY', flag: 'gy', dial_code: '+592 ' },
        { name: 'Haiti', code: 'HT', flag: 'ht', dial_code: '+509 ' },
        { name: 'Honduras', code: 'HN', flag: 'hn', dial_code: '+504 ' },
        { name: 'Hong Kong', code: 'HK', flag: 'hk', dial_code: '+852 ' },
        { name: 'Hungary', code: 'HU', flag: 'hu', dial_code: '+36 ' },
        { name: 'Iceland', code: 'IS', flag: 'is', dial_code: '+354 ' },
        { name: 'India', code: 'IN', flag: 'in', dial_code: '+91 ' },
        { name: 'Indonesia', code: 'ID', flag: 'id', dial_code: '+62 ' },
        { name: 'Iran', code: 'IR', flag: 'ir', dial_code: '+98 ' },
        { name: 'Iraq', code: 'IQ', flag: 'iq', dial_code: '+964 ' },
        { name: 'Ireland', code: 'IE', flag: 'ie', dial_code: '+353 ' },
        { name: 'Isle of Man', code: 'IM', flag: 'im', dial_code: '+44 ' },
        { name: 'Israel', code: 'IL', flag: 'il', dial_code: '+972 ' },
        { name: 'Italy', code: 'IT', flag: 'it', dial_code: '+39 ' },
        { name: 'Jamaica', code: 'JM', flag: 'jm', dial_code: '+1876 ' },
        { name: 'Japan', code: 'JP', flag: 'jp', dial_code: '+81 ' },
        { name: 'Jersey', code: 'JE', flag: 'je', dial_code: '+44 ' },
        { name: 'Jordan', code: 'JO', flag: 'jo', dial_code: '+962 ' },
        { name: 'Kazakhstan', code: 'KZ', flag: 'kz', dial_code: '+7 ' },
        { name: 'Kenya', code: 'KE', flag: 'ke', dial_code: '+254 ' },
        { name: 'Kiribati', code: 'KI', flag: 'ki', dial_code: '+686 ' },
        { name: 'Korea, North', code: 'KP', flag: 'kp', dial_code: '+850 ' },
        { name: 'Korea, South', code: 'KR', flag: 'kr', dial_code: '+82 ' },
        { name: 'Kuwait', code: 'KW', flag: 'kw', dial_code: '+965 ' },
        { name: 'Kyrgyzstan', code: 'KG', flag: 'kg', dial_code: '+996 ' },
        { name: 'Laos', code: 'LA', flag: 'la', dial_code: '+856 ' },
        { name: 'Latvia', code: 'LV', flag: 'lv', dial_code: '+371 ' },
        { name: 'Lebanon', code: 'LB', flag: 'lb', dial_code: '+961 ' },
        { name: 'Lesotho', code: 'LS', flag: 'ls', dial_code: '+266 ' },
        { name: 'Liberia', code: 'LR', flag: 'lr', dial_code: '+231 ' },
        { name: 'Libya', code: 'LY', flag: 'ly', dial_code: '+218 ' },
        { name: 'Liechtenstein', code: 'LI', flag: 'li', dial_code: '+423 ' },
        { name: 'Lithuania', code: 'LT', flag: 'lt', dial_code: '+370 ' },
        { name: 'Luxembourg', code: 'LU', flag: 'lu', dial_code: '+352 ' },
        { name: 'Macao', code: 'MO', flag: 'mo', dial_code: '+853 ' },
        { name: 'Madagascar', code: 'MG', flag: 'mg', dial_code: '+261 ' },
        { name: 'Malawi', code: 'MW', flag: 'mw', dial_code: '+265 ' },
        { name: 'Malaysia', code: 'MY', flag: 'my', dial_code: '+60 ' },
        { name: 'Maldives', code: 'MV', flag: 'mv', dial_code: '+960 ' },
        { name: 'Mali', code: 'ML', flag: 'ml', dial_code: '+223 ' },
        { name: 'Malta', code: 'MT', flag: 'mt', dial_code: '+356 ' },
        { name: 'Marshall Islands', code: 'MH', flag: 'mh', dial_code: '+692 ' },
        { name: 'Martinique', code: 'MQ', flag: 'mq', dial_code: '+596 ' },
        { name: 'Mauritania', code: 'MR', flag: 'mr', dial_code: '+222 ' },
        { name: 'Mauritius', code: 'MU', flag: 'mu', dial_code: '+230 ' },
        { name: 'Mexico', code: 'MX', flag: 'mx', dial_code: '+52 ' },
        { name: 'Micronesia', code: 'FM', flag: 'fm', dial_code: '+691 ' },
        { name: 'Moldova', code: 'MD', flag: 'md', dial_code: '+373 ' },
        { name: 'Monaco', code: 'MC', flag: 'mc', dial_code: '+377 ' },
        { name: 'Mongolia', code: 'MN', flag: 'mn', dial_code: '+976 ' },
        { name: 'Montenegro', code: 'ME', flag: 'me', dial_code: '+382 ' },
        { name: 'Montserrat', code: 'MS', flag: 'ms', dial_code: '+1664 ' },
        { name: 'Morocco', code: 'MA', flag: 'ma', dial_code: '+212 ' },
        { name: 'Mozambique', code: 'MZ', flag: 'mz', dial_code: '+258 ' },
        { name: 'Myanmar', code: 'MM', flag: 'mm', dial_code: '+95 ' },
        { name: 'Namibia', code: 'NA', flag: 'na', dial_code: '+264 ' },
        { name: 'Nauru', code: 'NR', flag: 'nr', dial_code: '+674 ' },
        { name: 'Nepal', code: 'NP', flag: 'np', dial_code: '+977 ' },
        { name: 'Netherlands', code: 'NL', flag: 'nl', dial_code: '+31 ' },
        { name: 'New Zealand', code: 'NZ', flag: 'nz', dial_code: '+64 ' },
        { name: 'Nicaragua', code: 'NI', flag: 'ni', dial_code: '+505 ' },
        { name: 'Niger', code: 'NE', flag: 'ne', dial_code: '+227 ' },
        { name: 'Nigeria', code: 'NG', flag: 'ng', dial_code: '+234 ' },
        { name: 'Niue', code: 'NU', flag: 'nu', dial_code: '+683 ' },
        { name: 'Norfolk Island', code: 'NF', flag: 'nf', dial_code: '+672 ' },
        { name: 'North Macedonia', code: 'MK', flag: 'mk', dial_code: '+389 ' },
        { name: 'Norway', code: 'NO', flag: 'no', dial_code: '+47 ' },
        { name: 'Oman', code: 'OM', flag: 'om', dial_code: '+968 ' },
        { name: 'Pakistan', code: 'PK', flag: 'pk', dial_code: '+92 ' },
        { name: 'Palau', code: 'PW', flag: 'pw', dial_code: '+680 ' },
        { name: 'Palestine', code: 'PS', flag: 'ps', dial_code: '+970 ' },
        { name: 'Panama', code: 'PA', flag: 'pa', dial_code: '+507 ' },
        { name: 'Papua New Guinea', code: 'PG', flag: 'pg', dial_code: '+675 ' },
        { name: 'Paraguay', code: 'PY', flag: 'py', dial_code: '+595 ' },
        { name: 'Peru', code: 'PE', flag: 'pe', dial_code: '+51 ' },
        { name: 'Philippines', code: 'PH', flag: 'ph', dial_code: '+63 ' },
        { name: 'Poland', code: 'PL', flag: 'pl', dial_code: '+48 ' },
        { name: 'Portugal', code: 'PT', flag: 'pt', dial_code: '+351 ' },
        { name: 'Puerto Rico', code: 'PR', flag: 'pr', dial_code: '+1 ' },
        { name: 'Qatar', code: 'QA', flag: 'qa', dial_code: '+974 ' },
        { name: 'Réunion', code: 'RE', flag: 're', dial_code: '+262 ' },
        { name: 'Romania', code: 'RO', flag: 'ro', dial_code: '+40 ' },
        { name: 'Russia', code: 'RU', flag: 'ru', dial_code: '+7 ' },
        { name: 'Rwanda', code: 'RW', flag: 'rw', dial_code: '+250 ' },
        { name: 'Saint Kitts and Nevis', code: 'KN', flag: 'kn', dial_code: '+1869 ' },
        { name: 'Saint Lucia', code: 'LC', flag: 'lc', dial_code: '+1758 ' },
        { name: 'Saint Vincent and the Grenadines', code: 'VC', flag: 'vc', dial_code: '+1784 ' },
        { name: 'Samoa', code: 'WS', flag: 'ws', dial_code: '+685 ' },
        { name: 'San Marino', code: 'SM', flag: 'sm', dial_code: '+378 ' },
        { name: 'Sao Tome and Principe', code: 'ST', flag: 'st', dial_code: '+239 ' },
        { name: 'Saudi Arabia', code: 'SA', flag: 'sa', dial_code: '+966 ' },
        { name: 'Senegal', code: 'SN', flag: 'sn', dial_code: '+221 ' },
        { name: 'Serbia', code: 'RS', flag: 'rs', dial_code: '+381 ' },
        { name: 'Seychelles', code: 'SC', flag: 'sc', dial_code: '+248 ' },
        { name: 'Sierra Leone', code: 'SL', flag: 'sl', dial_code: '+232 ' },
        { name: 'Singapore', code: 'SG', flag: 'sg', dial_code: '+65 ' },
        { name: 'Slovakia', code: 'SK', flag: 'sk', dial_code: '+421 ' },
        { name: 'Slovenia', code: 'SI', flag: 'si', dial_code: '+386 ' },
        { name: 'Solomon Islands', code: 'SB', flag: 'sb', dial_code: '+677 ' },
        { name: 'Somalia', code: 'SO', flag: 'so', dial_code: '+252 ' },
        { name: 'South Africa', code: 'ZA', flag: 'za', dial_code: '+27 ' },
        { name: 'South Sudan', code: 'SS', flag: 'ss', dial_code: '+211 ' },
        { name: 'Spain', code: 'ES', flag: 'es', dial_code: '+34 ' },
        { name: 'Sri Lanka', code: 'LK', flag: 'lk', dial_code: '+94 ' },
        { name: 'Sudan', code: 'SD', flag: 'sd', dial_code: '+249 ' },
        { name: 'Suriname', code: 'SR', flag: 'sr', dial_code: '+597 ' },
        { name: 'Sweden', code: 'SE', flag: 'se', dial_code: '+46 ' },
        { name: 'Switzerland', code: 'CH', flag: 'ch', dial_code: '+41 ' },
        { name: 'Syria', code: 'SY', flag: 'sy', dial_code: '+963 ' },
        { name: 'Taiwan', code: 'TW', flag: 'tw', dial_code: '+886 ' },
        { name: 'Tajikistan', code: 'TJ', flag: 'tj', dial_code: '+992 ' },
        { name: 'Tanzania', code: 'TZ', flag: 'tz', dial_code: '+255 ' },
        { name: 'Thailand', code: 'TH', flag: 'th', dial_code: '+66 ' },
        { name: 'Timor-Leste', code: 'TL', flag: 'tl', dial_code: '+670 ' },
        { name: 'Togo', code: 'TG', flag: 'tg', dial_code: '+228 ' },
        { name: 'Tonga', code: 'TO', flag: 'to', dial_code: '+676 ' },
        { name: 'Trinidad and Tobago', code: 'TT', flag: 'tt', dial_code: '+1868 ' },
        { name: 'Tunisia', code: 'TN', flag: 'tn', dial_code: '+216 ' },
        { name: 'Turkey', code: 'TR', flag: 'tr', dial_code: '+90 ' },
        { name: 'Turkmenistan', code: 'TM', flag: 'tm', dial_code: '+993 ' },
        { name: 'Turks and Caicos Islands', code: 'TC', flag: 'tc', dial_code: '+1649 ' },
        { name: 'Tuvalu', code: 'TV', flag: 'tv', dial_code: '+688 ' },
        { name: 'Uganda', code: 'UG', flag: 'ug', dial_code: '+256 ' },
        { name: 'Ukraine', code: 'UA', flag: 'ua', dial_code: '+380 ' },
        { name: 'United Arab Emirates', code: 'AE', flag: 'ae', dial_code: '+971 ' },
        { name: 'United Kingdom', code: 'GB', flag: 'uk', dial_code: '+44 ' },
        { name: 'United States', code: 'US', flag: 'us', dial_code: '+1 ' },
        { name: 'Uruguay', code: 'UY', flag: 'uy', dial_code: '+598 ' },
        { name: 'Uzbekistan', code: 'UZ', flag: 'uz', dial_code: '+998 ' },
        { name: 'Vanuatu', code: 'VU', flag: 'vu', dial_code: '+678 ' },
        { name: 'Vatican City', code: 'VA', flag: 'va', dial_code: '+379 ' },
        { name: 'Venezuela', code: 'VE', flag: 've', dial_code: '+58 ' },
        { name: 'Vietnam', code: 'VN', flag: 'vn', dial_code: '+84 ' },
        { name: 'Wallis & Futuna', code: 'WF', flag: 'wf', dial_code: '+681 ' },
        { name: 'Yemen', code: 'YE', flag: 'ye', dial_code: '+967 ' },
        { name: 'Zambia', code: 'ZM', flag: 'zm', dial_code: '+260 ' },
        { name: 'Zimbabwe', code: 'ZW', flag: 'zw', dial_code: '+263 ' }
      ],

      selectCountry(country) {
        this.selected = country;
        this.phone = country.dial_code;
        this.open = false;
      }
    }));
  });